import { render } from "./SampleInspectionFormLook.vue?vue&type=template&id=45d18a9a&scoped=true"
import script from "./SampleInspectionFormLook.vue?vue&type=script&lang=js"
export * from "./SampleInspectionFormLook.vue?vue&type=script&lang=js"

import "./SampleInspectionFormLook.vue?vue&type=style&index=0&id=45d18a9a&scoped=true&lang=css"
import "./SampleInspectionFormLook.vue?vue&type=style&index=1&id=45d18a9a&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d18a9a"]])

export default __exports__